import React from 'react';

import { BtmCtn, CardCtn, CardBody, PendingNumber, SvgCtn, TopCtn } from './index.style';

interface SummaryProps {
  summary: {
    count: number;
    title: string;
    icon: React.SVGProps<SVGSVGElement>;
  };
  onClick: ()=>{},

  // True until the real count has arrived: the number is drawn as a grey zero and then changes.
  pending?: boolean,
}

const JobSummaryCard: React.FC<SummaryProps> = ({ summary, onClick, pending = false }): React.ReactElement => {

  return (
    <CardCtn onClick={onClick}>
      <CardBody>
        <TopCtn>
          <SvgCtn>{summary.icon}</SvgCtn>
        </TopCtn>
        <BtmCtn>
          <div>{pending ? <PendingNumber aria-hidden="true" /> : summary.count}</div>
          <span>{summary.title}</span>
        </BtmCtn>
      </CardBody>
    </CardCtn>
  );
};

export default JobSummaryCard;
